import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mussAendern, setMussAendern] = useState(false);
  const [neuesPw, setNeuesPw] = useState("");
  const [neuesPw2, setNeuesPw2] = useState("");
  const [resetMode, setResetMode] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [mfaRequired, setMfaRequired] = useState(false);
  const [totpCode, setTotpCode] = useState("");
  const navigate = useNavigate();

  const login = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const body = { email, password };
      if (mfaRequired) body.totp_code = totpCode;
      const res = await fetch("/api/internal/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || "Login fehlgeschlagen"); return; }

      if (data.mfa_required) {
        setMfaRequired(true);
        return;
      }

      localStorage.setItem("internal_token", data.access_token);
      localStorage.setItem("internal_user", JSON.stringify(data.user));

      if (data.muss_passwort_aendern) {
        setMussAendern(true);
      } else {
        onLogin(data);
        navigate("/");
      }
    } catch { setError("Verbindungsfehler"); }
    finally { setLoading(false); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (neuesPw !== neuesPw2) { setError("Passwörter stimmen nicht überein"); return; }
    if (neuesPw.length < 10) { setError("Mindestens 10 Zeichen"); return; }
    setLoading(true);
    try {
      const res = await fetch("/api/internal/passwort-aendern", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, altes_passwort: password, neues_passwort: neuesPw })
      });
      if (!res.ok) { setError("Fehler beim Ändern"); return; }
      // Neu einloggen
      const loginRes = await fetch("/api/internal/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password: neuesPw })
      });
      const data = await loginRes.json();
      localStorage.setItem("internal_token", data.access_token);
      localStorage.setItem("internal_user", JSON.stringify(data.user));
      onLogin(data);
      navigate("/");
    } catch { setError("Fehler"); }
    finally { setLoading(false); }
  };

  const sendReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    await fetch("/api/internal/passwort-reset-anfrage", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email })
    });
    setResetSent(true);
    setLoading(false);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5" }}>
      <div style={{ background: "white", borderRadius: 8, padding: 40, width: 380, boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 48, height: 48, background: "var(--red)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, margin: "0 auto 12px" }}>🚒</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>FFW Sitzungsmanagement</h1>
          <div style={{ fontSize: 13, color: "#999" }}>Bitte melden Sie sich an</div>
        </div>

        {error && <div style={{ background: "var(--danger-bg)", color: "var(--danger)", padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 13 }}>{error}</div>}

        {resetSent ? (
          <div style={{ textAlign: "center", color: "var(--ok)" }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
            <div>Falls die E-Mail-Adresse bekannt ist, erhalten Sie einen Reset-Link.</div>
            <button className="btn btn-secondary" style={{ marginTop: 16 }} onClick={() => { setResetMode(false); setResetSent(false); }}>Zurück zum Login</button>
          </div>
        ) : resetMode ? (
          <form onSubmit={sendReset}>
            <div style={{ marginBottom: 16 }}>
              <label htmlFor="login-reset-email" style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>E-Mail-Adresse</label>
              <input id="login-reset-email" type="email" autoComplete="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Wird gesendet…" : "Reset-Link senden"}
            </button>
            <button type="button" className="btn btn-ghost" style={{ width: "100%", marginTop: 8 }} onClick={() => setResetMode(false)}>Zurück</button>
          </form>
        ) : mussAendern ? (
          <form onSubmit={changePassword}>
            <div style={{ background: "#fff8e1", padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
              Bitte vergeben Sie ein neues Passwort.
            </div>
            <div style={{ marginBottom: 12 }}>
              <label htmlFor="login-neues-pw" style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>Neues Passwort</label>
              <input id="login-neues-pw" type="password" autoComplete="new-password" className="form-control" value={neuesPw} onChange={e => setNeuesPw(e.target.value)} required minLength={10} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label htmlFor="login-neues-pw2" style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>Passwort wiederholen</label>
              <input id="login-neues-pw2" type="password" autoComplete="new-password" className="form-control" value={neuesPw2} onChange={e => setNeuesPw2(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Wird gespeichert…" : "Passwort setzen & anmelden"}
            </button>
          </form>
        ) : mfaRequired ? (
          <form onSubmit={login}>
            <div style={{ background: "#e3f2fd", padding: "10px 14px", borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
              Bitte den Code aus Ihrer Authenticator-App eingeben (oder einen Backup-Code).
            </div>
            <div style={{ marginBottom: 20 }}>
              <label htmlFor="login-totp-code" style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>Code</label>
              <input id="login-totp-code" type="text" inputMode="numeric" autoComplete="one-time-code" className="form-control" value={totpCode}
                     onChange={e => setTotpCode(e.target.value)} required autoFocus
                     placeholder="123456" style={{ letterSpacing: 2, fontSize: 18, textAlign: "center" }} />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Wird geprüft…" : "Bestätigen"}
            </button>
            <button type="button" className="btn btn-ghost" style={{ width: "100%", marginTop: 8, fontSize: 12 }}
                    onClick={() => { setMfaRequired(false); setTotpCode(""); setError(""); }}>
              Zurück
            </button>
          </form>
        ) : (
          <form onSubmit={login}>
            <div style={{ marginBottom: 12 }}>
              <label htmlFor="login-email" style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>E-Mail-Adresse</label>
              <input id="login-email" type="email" autoComplete="email" className="form-control" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label htmlFor="login-password" style={{ fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 4, display: "block" }}>Passwort</label>
              <input id="login-password" type="password" autoComplete="current-password" className="form-control" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }} disabled={loading}>
              {loading ? "Wird angemeldet…" : "Anmelden"}
            </button>
            <button type="button" className="btn btn-ghost" style={{ width: "100%", marginTop: 8, fontSize: 12 }} onClick={() => setResetMode(true)}>
              Passwort vergessen?
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
